import { fullStamp, parseTs } from '../lib/time.ts'
import { h } from '../charts/svg.ts'
import { columnIndex, num, type Table } from '../sdk/search.ts'

const PREVIEW_ROWS = 200

/**
 * Exactly what came back from log_search, so the numbers above can be checked
 * against their source. Rows are newest-first as the cloud returns them.
 */
export function renderDataTable(title: string, subtitle: string, table: Table): HTMLElement {
  const tsIdx = columnIndex(table, 'ts')
  const shown = table.rows.slice(0, PREVIEW_ROWS)

  const head = h(
    'tr',
    {},
    ...table.columns.map((c) => h('th', { text: c })),
    h('th', { text: 'ts (parsed, UTC)' }),
  )

  const body = h(
    'tbody',
    {},
    ...shown.map((row) => {
      const ms = tsIdx >= 0 ? parseTs(row[tsIdx]) : null
      return h(
        'tr',
        {},
        ...row.map((cell) =>
          h('td', { class: num(cell) !== null ? 'num tabular' : '', text: cell === '' ? '—' : cell }),
        ),
        h('td', { class: ms === null ? 'muted' : '', text: ms === null ? 'unparseable' : fullStamp(ms) }),
      )
    }),
  )

  const csvBtn = h('button', { class: 'btn btn-sm', type: 'button', text: 'Copy CSV' })
  csvBtn.addEventListener('click', async () => {
    const csv = [table.columns, ...table.rows]
      .map((r) => r.map((c) => (/[",\n]/.test(c) ? `"${c.replace(/"/g, '""')}"` : c)).join(','))
      .join('\n')
    try {
      await navigator.clipboard.writeText(csv)
      csvBtn.textContent = 'Copied'
      setTimeout(() => (csvBtn.textContent = 'Copy CSV'), 1500)
    } catch {
      csvBtn.textContent = 'Clipboard blocked'
      setTimeout(() => (csvBtn.textContent = 'Copy CSV'), 1500)
    }
  })

  return h(
    'div',
    { class: 'chart-block' },
    h(
      'div',
      { class: 'dev-head' },
      h('h3', { text: title }),
      h('span', { class: 'pill', text: `${table.rows.length.toLocaleString('en-GB')} rows · ${table.pages} page${table.pages === 1 ? '' : 's'}` }),
      table.truncated ? h('span', { class: 'pill', text: 'page guard hit' }) : null,
      h('span', { class: 'spacer', style: 'flex:1' }),
      csvBtn,
    ),
    h('div', { class: 'chart-sub', text: subtitle }),
    table.rows.length === 0
      ? h('div', { class: 'empty', text: 'No rows in this window.' })
      : h(
          'div',
          { class: 'table-scroll' },
          h('table', { class: 'data' }, h('thead', {}, head), body),
        ),
    table.rows.length > PREVIEW_ROWS
      ? h('div', {
          class: 'chart-sub',
          text: `Showing the first ${PREVIEW_ROWS} of ${table.rows.length.toLocaleString('en-GB')} rows — Copy CSV takes all of them.`,
        })
      : null,
  )
}
